import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { RapoarteClientTableService } from 'src/app/modules/acbcr/common/services/rapoarte-client.service';

@Component({
  selector: 'app-raport-client',
  templateUrl: './raport-client.component.html',
  styleUrls: ['./raport-client.component.scss']
})
export class RaportClientComponent implements OnInit, OnDestroy {

  tables$: Observable<any[]>;
  total$: Observable<number>;
  loadingDataSpinner = false;

  objToAPI = {
    expl_id: null,
    page_no: '1',
    page_size: '10'
  };

  constructor(
    public raportClientService: RapoarteClientTableService,
    public helperDataService: HelperDataService
  ) {
    this.tables$ = raportClientService.tables$;
    this.total$ = raportClientService.total$;
  }

  ngOnInit(): void {}

  getTableData() {
    this.loadingDataSpinner = true;
    this.raportClientService
      .getRapoarteClientAPI(this.objToAPI).subscribe((response) => {
        setTimeout(() => {
          this.loadingDataSpinner = false;
        }, 500);
      });
  }

  filterSearchData(event) {
    this.objToAPI = {
      ...this.objToAPI,
      ...event,
    };

    if (!event.expl_id) {
      this.raportClientService.clearRapoarteTable();
      this.loadingDataSpinner = false;
      return;
    }

    this.getTableData();
  }

  exportData(event) {
    this.raportClientService
      .exportXLS(this.objToAPI)
      .subscribe((response) => {
        const blob = new Blob([response], { type: 'application/octet-stream' });
        this.helperDataService.simulateDownload( blob, `Rapoarte-client.xls`);
      });
  }

  changePageSize(event) {
    this.objToAPI.page_size = event;
    this.getTableData();
  }

  changePageNumber(event) {
    this.objToAPI.page_no = event;
    this.getTableData();
  }

  ngOnDestroy(): void {
    this.raportClientService.clearRapoarteTable();
  }

}
